import { Component, OnInit } from "@angular/core";
import { DataProviderService } from "../../../service/data-provider.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-hwwe",
  templateUrl: "./hwwe.component.html",
  styleUrls: ["./hwwe.component.css"]
})
export class HwweComponent implements OnInit {
  eventData: any;
  News: any;
  constructor(
    public datapro: DataProviderService,
    public data: DataProviderService,
    public route: ActivatedRoute
  ) {
    let id = this.route.snapshot.paramMap.get("id");
    this.eventData = this.data.eventsWebpage[id];
    this.News = this.datapro.newSinglesample;
  }
  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
